import React from 'react';

// Small brand-coloured glyphs for rows that carry an `icon` key (the
// Consumer Voice source sub-rows on /pricing). Simplified marks drawn
// inline so they work in the embed and need no asset pipeline; unknown
// keys render nothing.
const SIZE = 16;
const wrap: React.CSSProperties = {
  display: 'inline-block',
  verticalAlign: 'middle',
  marginRight: 8,
  flex: '0 0 auto',
};

const glyphs: Record<string, React.ReactElement> = {
  reddit: (
    <svg width={SIZE} height={SIZE} viewBox="0 0 24 24" style={wrap} aria-hidden="true">
      <circle cx="12" cy="12" r="12" fill="#FF4500" />
      <ellipse cx="12" cy="14" rx="6.2" ry="4.4" fill="#FFFFFF" />
      <circle cx="6.2" cy="12.2" r="1.5" fill="#FFFFFF" />
      <circle cx="17.8" cy="12.2" r="1.5" fill="#FFFFFF" />
      <circle cx="9.7" cy="13.6" r="1" fill="#FF4500" />
      <circle cx="14.3" cy="13.6" r="1" fill="#FF4500" />
      <path d="M9.6 16.3c1.4 1 3.4 1 4.8 0" stroke="#FF4500" strokeWidth="0.9" fill="none" strokeLinecap="round" />
      <path d="M12 9.6l1-3.4 3 .8" stroke="#FFFFFF" strokeWidth="0.9" fill="none" strokeLinecap="round" />
      <circle cx="16.4" cy="6.8" r="1.1" fill="#FFFFFF" />
    </svg>
  ),
  youtube: (
    <svg width={SIZE} height={SIZE} viewBox="0 0 24 24" style={wrap} aria-hidden="true">
      <rect x="1" y="5" width="22" height="14" rx="4" fill="#FF0000" />
      <path d="M10 9l5.5 3-5.5 3z" fill="#FFFFFF" />
    </svg>
  ),
  google_trends: (
    <svg width={SIZE} height={SIZE} viewBox="0 0 24 24" style={wrap} aria-hidden="true">
      <path d="M3 17l5-6 4 3 4-6 5 4" stroke="#4285F4" strokeWidth="2.4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="21" cy="12" r="2.2" fill="#EA4335" />
    </svg>
  ),
  google: (
    <svg width={SIZE} height={SIZE} viewBox="0 0 24 24" style={wrap} aria-hidden="true">
      <path d="M21.6 12.2c0-.7-.1-1.3-.2-1.9H12v3.7h5.4c-.2 1.2-.9 2.3-2 3v2.5h3.2c1.9-1.7 3-4.3 3-7.3z" fill="#4285F4" />
      <path d="M12 22c2.7 0 5-.9 6.6-2.4l-3.2-2.5c-.9.6-2 1-3.4 1-2.6 0-4.8-1.8-5.6-4.1H3.1v2.6C4.8 19.8 8.1 22 12 22z" fill="#34A853" />
      <path d="M6.4 13.9A6 6 0 016.1 12c0-.7.1-1.3.3-1.9V7.5H3.1A10 10 0 002 12c0 1.6.4 3.1 1.1 4.5l3.3-2.6z" fill="#FBBC05" />
      <path d="M12 6c1.5 0 2.8.5 3.8 1.5l2.9-2.9C17 3 14.7 2 12 2 8.1 2 4.8 4.2 3.1 7.5l3.3 2.6C7.2 7.8 9.4 6 12 6z" fill="#EA4335" />
    </svg>
  ),
  search_console: (
    <svg width={SIZE} height={SIZE} viewBox="0 0 24 24" style={wrap} aria-hidden="true">
      <rect x="2" y="3" width="20" height="18" rx="3" fill="#4285F4" />
      <rect x="6" y="12" width="3" height="6" fill="#FFFFFF" />
      <rect x="10.5" y="8" width="3" height="10" fill="#FFFFFF" />
      <rect x="15" y="10" width="3" height="8" fill="#FBBC05" />
    </svg>
  ),
  reviews: (
    <svg width={SIZE} height={SIZE} viewBox="0 0 24 24" style={wrap} aria-hidden="true">
      <path d="M12 2.5l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.4l-5.9 3.1 1.2-6.5L2.5 9.4l6.6-.9z" fill="#F5A623" />
    </svg>
  ),
  qa: (
    <svg width={SIZE} height={SIZE} viewBox="0 0 24 24" style={wrap} aria-hidden="true">
      <path d="M4 4h16a2 2 0 012 2v9a2 2 0 01-2 2h-8l-5 4v-4H4a2 2 0 01-2-2V6a2 2 0 012-2z" fill="#5B6B7A" />
      <path d="M9.6 9.2a2.5 2.5 0 014.8.8c0 1.6-2.2 1.9-2.2 3.2" stroke="#FFFFFF" strokeWidth="1.6" fill="none" strokeLinecap="round" />
      <circle cx="12.2" cy="15.6" r="1" fill="#FFFFFF" />
    </svg>
  ),
};

export function SourceIcon({ name }: { name?: string }) {
  if (!name) return null;
  return glyphs[name] || null;
}
